<template>
  <div>
    <settings-card
      v-loading="loading"
      :config="config">
      <el-button
        type="text"
        @click="setting">去设置</el-button>
    </settings-card>
    <el-dialog
      :title="config.title"
      :visible.sync="visible"
      width="450px">
      <el-form
        ref="form"
        label-width="140px"
        :rules="rules"
        :model="form">
        <el-form-item
          label="积分折现比例："
          prop="pointsToCashRatio">
          <el-input-number
            v-model="form.pointsToCashRatio"
            :min="0"
            :controls="false"></el-input-number> 积分抵扣¥1。
        </el-form-item>
        <el-form-item
          label="支付金额百分比："
          prop="pointsCashPayPercent">
          <el-input-number
            v-model="form.pointsCashPayPercent"
            :min="0"
            :max="100"
            :controls="false"
          ></el-input-number> %
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button
          type="primary"
          @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import SettingsCard from './settings-card.vue'
export default {
  name: 'PointCashCard',
  components: { SettingsCard },
  props: {
    config: {
      type: Object,
      default() {
        return {}
      }
    },
    vendorId: [String, Number]
  },
  data() {
    return {
      loading: false,
      visible: false,
      form: {
        pointsToCashRatio: 0,
        pointsCashPayPercent: 50
      },
      rules: {
        pointsToCashRatio: [
          { required: true, message: '请输入积分折现比例', trigger: 'blur' }
        ],
        pointsCashPayPercent: [
          { required: true, message: '请输入支付金额百分比', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    setting() {
      this.getsetting(() => {
        this.visible = true
      })
    },
    getsetting(cb) {
      this.loading = true
      this.$store.dispatch('wxaccount/getvendor', {
        payload: {
          vendorId: this.vendorId
        },
        success: res => {
          this.loading = false
          this.form.pointsToCashRatio = res.data.pointsToCashRatio
          this.form.pointsCashPayPercent = res.data.pointsCashPayPercent
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$store.dispatch('wxaccount/setpoints2cashratio', {
            payload: {
              vendorId: this.vendorId,
              ...this.form
            },
            success: () => {
              this.loading = false
              // this.visible = false
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
